import { videos } from "../../../images/video-list-content";

export const getVideoListContent = () => {
	return videos;
};
